import req from './../../../../fetch';
import { paramsToString, undocumentedResponse } from './../../../../utils';
import { AllAPIResponses, CarbonError, NodeType } from './../../../../index';

type Params = {
  detail?: boolean;
  limit?: number;
  offset?: number;
};

const get = async (
  params: Params,
  id: number,
  headers?: Headers
): Promise<AllAPIResponses<NodeType[]>> => {
  try {
    const resp = await req.get(
      `/api/folders/${id}/nodes${paramsToString(params)}`,
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: (await resp.json()) as NodeType[],
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default get;
